export const changeEnterPriseReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_ENTERPRISE":
      return action.payload.enterprise;
    default:
      return state;
  }
};
